import { render, staticRenderFns } from "./Advert.vue?vue&type=template&id=2cce19f0&scoped=true&"
import script from "./Advert.vue?vue&type=script&lang=ts&"
export * from "./Advert.vue?vue&type=script&lang=ts&"
import style0 from "./Advert.vue?vue&type=style&index=0&id=2cce19f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cce19f0",
  null
  
)

component.options.__file = "Advert.vue"
export default component.exports